export default __webpack_public_path__ + "static/media/team_6.7dae3700.jpg";